import type { ProgramDetails, ProgramRelated } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';
import { formatToPTBRDate } from '@/utils/date';

const getProgramRelated = async (id: ProgramDetails['id'], limit = 4) => {
  try {
    const { data } = await api.get<{ data: ProgramRelated[] }>(
      apiConfig.routes.entertainment.program.relatedContents(id),
      { params: { limit } }
    );
    return data.data;
  } catch {
    const { data } = await api.get<{ data: ProgramRelated[] }>(
      apiConfig.routes.entertainment.program.publicRelatedContents(id),
      { params: { limit } }
    );
    return data.data;
  }
};

export const useGetProgramRelated = (id: ProgramDetails['id'], limit = 4) =>
  useQuery({
    queryKey: ['program', id, 'related', limit],
    queryFn: () => getProgramRelated(id, limit),
    enabled: !!id,
    select: (data) =>
      data.map(({ published_at, ...rest }) => {
        const [day, month, year] = published_at.split('/');
        const formattedDate = formatToPTBRDate(`${year}-${month}-${day}`, {
          month: 'long',
        }).replace(/ de (\d{4})/, ', $1');
        return { ...rest, published_at: formattedDate };
      }),
  });
